import { styled } from 'src/styles/stitches.config'

export const Wrapper = styled('div', {
    textAlign: 'justify',
    '@lg': {
        width: '50%',
    },
})
